import React from 'react';
import styles from './Squares.module.scss';

const Squares = ({ squares }) => {
  const types = ['orange', 'red', 'black'];

  return (
    <div className={ styles.Squares }>
      { squares.map((item, i) => 
        <Square key={ item.number } { ...item }
          type={types[i]}
        />) }
    </div>
  );
};

const Square = ({ number, text, type }) => {
  const classes = `${styles.Square} ${styles[type]}`;

  return (
    <div className={ classes }>
      <h2>{ number }</h2>
      <p>{ text }</p>
    </div>
  );
};
 
export default Squares;